<template>
  <div class="relative">
    <div v-if="formData.details.length" class="sticky top-0 left-0 z-10 w-full flex items-center justify-between mt-0 px-6 py-4" :class="Math.sign(formData.amount) === -1 ? 'bg-red-200' : 'bg-teal-200'">
      
      <div class="hidden md:flex md:items-center md:w-auto w-full order-3 md:order-1">
        <div class="md:flex items-center justify-between text-base text-orange-600 pt-4 md:pt-0">
          <svg :class="Math.sign(formData.amount) === -1 ? 'text-red-600' : 'text-teal-600'" class="h-8 w-8 mr-4 inline" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
          </svg>
          <div :class="Math.sign(formData.amount) === -1 ? 'text-red-800' : 'text-teal-800'" class="text-lg inline">
            {{ `${formData.details.length} orders are selected` }}
          </div>
        </div>
      </div>

      <div class="order-2 md:order-3 flex flex-wrap items-center justify-end mr-0 md:mr-4">
        <div class="auth flex items-center w-full md:w-full">
          <div :class="Math.sign(formData.amount) === -1 ? 'text-red-800' : 'text-teal-800'" class="font-bold text-lg inline">
            {{ $t('total_amount') }}:
            <span>{{ formData.amount }} <sup>{{ cuurency }}</sup></span>
          </div>
        </div>
      </div>

    </div>

    <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
      <div class="bg-white w-fullrounded-lg shadow form-payement">
        <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
          
          <div class="flex w-1/3">
            <router-link :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3" to="/payments">
              <i class="material-icons mx-2">chevron_left</i>
            </router-link>
            <div v-if="!formData._id" class="text-2xl font-bold text-orange-500">
              {{ $t('new_payement') }}
            </div>
          </div>

          <div class="w-full flex justify-end space-x-4">
            <button class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-orange-600 hover:shadow-inner hover:bg-orange-700 transition-all duration-300" @click="OpenClosePopPayMethode('open', 'selectOrders')">
              {{ $t('pay') }}
            </button>
          </div>

        </div>

        <div class="">
          <div class="bg-white rounded-lg p-6 pt-2">
            <div class="-mx-3 md:flex mb-6 border p-5 border-dotted rounded-md border-gray-500">
              <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                
                <div class="border h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                      <label for="seller" class="bg-white text-gray-700 px-1">{{ $t('select_seller') }}
                        <span :class="$colors.required">*</span>
                      </label>
                    </p>
                  </div>
                  <p>
                    <v-select v-model="formData.seller" label="company" :options="sellers" @input="getOrdersBySeller" @search="searchSellers($event, 'hh')" />
                  </p>
                </div>

                <div v-if="formData.seller && formData.seller._id && formData.seller._id.toString() === '64d60cfc05f818068c8f4750'" class="border mt-5 h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                      <label for="seller" class="bg-white text-gray-700 px-1">{{ $t('Affiliate stores') }}
                        <span :class="$colors.required">*</span></label>
                    </p>
                  </div>
                  <p>
                    <v-select v-model="formData.ThirdParty" :options="stores" @input="getOrdersBySeller($event, 'ThirdParty')" />
                  </p>
                </div>

              </div>
              <div class="md:w-1/2 px-3">
                <div v-if="formData.seller" class="inline-block w-full">
                  
                  <div class="inline-block w-1/3 pr-1">
                    <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="date" class="bg-white text-gray-700 px-1">From 
                            <span class="text-orange-500">*</span>
                          </label>
                        </p>
                      </div>
                      <p>
                        <input id="from" v-model="dateDelevery.fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" type="date" />
                      </p>
                    </div>
                  </div>

                  <div class="inline-block w-1/3 pr-1">
                    <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="date" class="bg-white text-gray-700 px-1">To <span
                              class="text-orange-500">*</span></label>
                        </p>
                      </div>
                      <p>
                        <input id="to" v-model="dateDelevery.toDate"
                          class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" type="date" />
                      </p>
                    </div>
                  </div>

                  <div class="inline-block text-right w-1/3 pr-1">
                    <button :disabled="dateDelevery.fromDate === null || dateDelevery.toDate === null " class="w-1/2 mr-2 px-2 py-2 text-white font-light tracking-wider bg-orange-700 rounded" @click="FindOrderByBetweenDate">
                      Find
                    </button>
                    <button class="w-1/4 px-2 py-2 text-orange-500 hover:text-white font-light tracking-wider bg-gray-300 hover:bg-orange-600 rounded" @click="reset">
                      Reset
                    </button>
                  </div>

                </div>
              </div>
            </div>
            <div>
              <!-- Order selectioner -->
              <div v-if="orders.length > 0" class="mt-5 overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
                <div class="w-full bg-white mt-1 mb-5 shadow-lg border overflow-hidden">

                  <div class="py-2 text-center font-bold uppercase tracking-wide text-white bg-orange-700">
                    Seller: {{ formData.seller.fullName }}
                  </div>

                  <div class="flex items-center justify-between py-2 px-3 bg-gray-400">
                    <h1 class="text-gray-800 font-bold">
                      <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
                      {{ totalOrdersAmountFees() }}
                      <span>(Total orders:
                        {{ totalOrdersAmountFees().count }})
                      </span>
                    </h1>
                    <button class="bg-gray-800 text-xs text-white px-5 py-1 font-semibold rounded uppercase hover:bg-gray-700 relative loading-amount" :class="loadingShowPay ? 'disabled-loading' : ''" @click="OpenClosePopPayMethode('open', 'allOrders')">
                      <loading v-model:active="loadingShowPay" :is-full-page="fullPage" />Pay all
                    </button>
                  </div>

                </div>

                <loading v-model:active="loading" :is-full-page="fullPage" />

                <table class="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                  <thead>
                    <tr class="text-left">
                      
                      <th class="py-1 px-3 sticky top-0 border-b bg-orange-700 text-white border-gray-300">
                        <label class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                          <input type="checkbox"
                            class="form-checkbox checkallbbox focus:outline-none focus:shadow-outline"
                            @click="selectAllCheckbox($event)" />
                        </label>
                      </th>

                      <th v-for="(heading, ind) in headings" :key="ind" class="text-center px-1 text-xss font-bold uppercase bg-orange-700 text-white border border-gray-300">
                        {{ heading.value }}
                      </th>

                    </tr>
                  </thead>

                  <TableBody v-for="(order, ind) in orders" :key="ind" :item="order" :services-seller="servicesSeller" :isconf_vat="is_conf_vat"
                    :cities-prices="citiesPrices" :warehouse="warehouse" :id-wharhouse="idWharhouse" :upsellvat="upsell_vat"
                    :cuurency="cuurency" :qu_control="quality_control" :confvat="confirmation_vat" :gl_vat="global_vat"
                    :fulvat="fulfillement_fees_vat" :ship_vat="shipping_vat" :def_ship_vat="default_shipping_vat"
                    :ship_refund_vat="shipping_refund_vat" :ship_cancel_vat="shipping_cancel_vat" :form-data="formData"
                    @getRowDetail="getRowDetail" @UpdateRowFees="UpdateRowFees" />
                  </table>

                <!-- Expedition -->
                <table v-if="expeditions.length > 0" class="min-w-full">
                  <thead>
                    <tr>
                      <th :colspan="7" class="text-center bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        Expeditions
                      </th>
                    </tr>
                  </thead>

                  <thead>
                    <tr>
                      
                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider" />

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('ID') }}
                      </th>

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('nb_packages') }}
                      </th>

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('transport_mode') }}
                      </th>

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('details') }}
                      </th>

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('country') }}
                      </th>

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('expedition_fees') }}
                      </th>

                      <th class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-orange-500 tracking-wider">
                        {{ $t('Package Fees') }}
                      </th>

                    </tr>
                  </thead>

                  <tbody class="bg-white">
                    <tr v-for="(exp, ind) in expeditions" :key="ind">
                      <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 text-center">
                        <input :id="exp._id" type="checkbox" class="form-checkbox checkbox-exp focus:outline-none focus:shadow-outline" @click="getRowDetailExp($event, exp, exp._id)" />
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap text-center">
                        <div class="text-sm leading-5 text-orange-900 capitalize">
                          {{ exp.id }}
                        </div>
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap text-center">
                        <div class="text-sm leading-5 text-orange-900 capitalize">
                          {{ exp.numberOfPackages }}
                        </div>
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap ext-center">
                        <div class="text-sm leading-5 text-orange-900 capitalize">
                          {{ exp.transportMode }}
                        </div>
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap text-center">
                        <div class="text-sm leading-5 text-orange-900 capitalize">
                          {{ exp.details.length }} {{ $t('products') }}
                        </div>
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap text-center">
                        <div class="text-sm leading-5 text-orange-900 capitalize">
                          {{ exp.country }}
                        </div>
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap text-center">
                        <div class="text-sm leading-5 font-bold text-orange-900 capitalize">
                          {{ exp.fees }}
                        </div>
                      </td>

                      <td class="px-6 py-2 border-b-2 whitespace-no-wrap text-center">
                        <div class="text-sm leading-5 font-bold text-orange-900 capitalize">
                          {{ exp.packageFees }}
                        </div>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- order by seller -->
              <div v-if="orders.length === 0" class="mt-6" style="overflow-x: auto">
                <table class="min-w-full w-full">
                  <thead class="relative">
                    <tr class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">

                      <th class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                        <span> Seller </span>
                      </th>

                      <th class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                        <span> Number of orders </span>
                      </th>

                      <th class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                        <span> Amount to pay </span>
                      </th>

                      <th class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                        <span> Action </span>
                      </th>

                    </tr>
                  </thead>

                  <loading v-model:active="loadingorderbyseller" :is-full-page="fullPage" />
                  
                  <TableTotalAmount v-for="(totalorders, index) in ordersByseller" :key="index"
                    :seller-select="sellerSelect" :loading-show-pay="loadingShowPay" :item="totalorders"
                    :cities-prices="citiesPrices" :warehouse="warehouse" :id-wharhouse="idWharhouse"
                    :cuurency="cuurency" @getOrdersBySeller="getOrdersBySeller"
                    @OpenClosePopPayMethode="OpenClosePopPayMethode" />
                </table>

              </div>
              <!-- /order by seller -->
              <div v-if="orders.length === 0 && ordersByseller.length === 0" class="relative bg-orange-100 py-8 mt-1">
                <loading v-model:active="loading" :is-full-page="fullPage" />
                <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                  <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                    <i class="material-icons mx-3">error</i>
                    <span class>{{ $t('no_order_to_paid') }}</span>
                  </p>
                </span>
              </div>

              <!-- pagination -->
              <div v-if="paginate.lastpage > 1" class="p-1">
                <div class="flex flex-col items-center my-12">
                  <button v-if="paginate.currentpage < paginate.lastpage"
                    :disabled="paginate.currentpage === paginate.lastpage" class="custom-btn btn-16" @click="loadMore">
                    Show more data
                  </button>
                </div>
              </div>
              <!-- end pagination -->
              
              <!-- end  Order selectioner -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-modal-2 name="ModalPay" :header-options="{ title: $t('payement_methode') }" :no-footer="true" modal-size="lg">
      <vue-ins-progress-bar />

      <loading v-model:active="loadingPay" :is-full-page="fullPage" />
      <div class="bg-white rounded-lg">
        <div class="w-96 rounded-lg flex">
          <div class="w-1/3 pt-6 flex justify-center items-center">
            <span class="w-16 h-16 bg-orange-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px">payment</i></span>
          </div>

          <div class="w-full pr-4">
            <h3 class="font-bold text-orange-600 mb-5">
              {{ $t('payement_methode') }}
            </h3>

            <div class="w-full px-4">
              <div class="mb-5 border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="country" class="bg-white text-gray-700 px-1">
                      {{ $t('payement_methode') }}
                      </label>
                  </p>
                </div>

                <p>
                  <v-select v-model="formData.method" :options="options" label="name" @input="setSelected">
                    <template #option="option">
                      <img class="flag-img" :src="getImagePay(option.name)" />
                      {{ option.name }}
                    </template>
                  </v-select>
                </p>

              </div>
            </div>

            <div class="header-tabl app-theme border-top border-top-dashed mt-2">
              <div class="w-full">
                <div class="title title-1 p-1">
                  <button id="invoice-item-add" title="Add Item" class="btn btn-prime loidingconfirm relative" :class="loadingPay ? 'noselect' : ''" @click="AddRefunds()">
                    <loading v-model:active="loadingPay" :is-full-page="fullPage" />Add Remboursements<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus ml-2 fa-w-14">
                      <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <table class="invoice-table table table-borderless table-nowrap mb-0 w-full">
              <thead class="align-middle">
                <tr>
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                  <th />
                </tr>
              </thead>

              <tbody>
                <tr class="border-top border-top-dashed mt-2">
                  <td class="w-1/3" colspan="3" />
                  <td colspan="2" class="p-0">
                    
                    <table class="table table-borderless table-sm table-nowrap align-middle mb-0 w-full">
                      <tbody>

                        <tr>
                          <th scope="row">
                            Sub Total
                            <small>({{ formData.details.length }} orders)</small>
                          </th>
                          <td style="width: 150px">
                            <input id="cart-subtotal" type="text" class="form-control bg-light border-0" :placeholder="subtotalCalculate()" readonly="" />
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">Total Fees</th>
                          <td>
                            <input id="cart-discount" type="text" class="form-control bg-light border-0" :placeholder="`${idWharhouse ? idWharhouse.currency : ''} ${formData.totalFees ? formData.totalFees : 0 }` " readonly="" />
                          </td>
                        </tr>

                        <tr v-if="expeditions.length > 0">
                          <th scope="row">Expeditions Fees</th>
                          <td>
                            <input id="cart-discount" type="text" class="form-control bg-light border-0" :placeholder="`${idWharhouse ? idWharhouse.currency : ''} ${expeditions.reduce((n, { fees, packageFees }) => n + fees + packageFees, 0) }` " readonly="" />
                          </td>
                        </tr>

                        <tr v-if="formData.tva">
                          <th scope="row">Tva Fees ({{ formData.tva }}%)</th>
                          <td>
                            <input id="cart-tax" type="text" class="form-control bg-light border-0" :placeholder="`${idWharhouse ? idWharhouse.currency : ''} ${formData.vatFees ? formData.vatFees : 0 }`" readonly="" />
                          </td>
                        </tr>

                        <tr v-if="formData.refunds.length > 0">
                          <th scope="row">
                            Remboursements
                            <small>({{ formData.refunds.length }} orders)</small>
                          </th>
                          <td>
                            <input id="cart-tax" type="text" class="form-control bg-light border-0" :placeholder="`${idWharhouse ? idWharhouse.currency : '' } ${formData.refunds.map(item => item.fees).reduce((prev, curr) => prev + curr, 0)}`" readonly="" />
                          </td>
                        </tr>

                        <tr class="border-top border-top-dashed">
                          <th scope="row">Total Amount</th>
                          <td>
                            <input id="cart-total" type="text" class="form-control bg-light border-0" :placeholder="`${idWharhouse ? idWharhouse.currency : '' } ${formData.amount}`" readonly="" />
                          </td>
                        </tr>

                      </tbody>
                    </table>
                    <!-- end table -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="p-4 flex space-x-4">
          <a href="#" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm" @click="OpenClosePopPayMethode('close')">{{ $t('cancel') }}</a>
          <a href="#" class="w-1/2 px-4 py-3 text-center text-orange-100 bg-orange-600 rounded-lg hover:bg-orange-700 hover:text-white font-bold text-sm" @click="save">{{ $t('confirm') }}</a>
        </div>

      </div>
    </vue-modal-2>

    <vue-modal-2 class="moukhtar" name="ModalRefunds" :header-options="{ title: 'Remboursements' }" :no-footer="true" modal-size="xl">
      <div class="flex flex-col w-full h-auto p-5 pt-0 bottom_bitt">
        <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg" style="margin-bottom: 62px">
          <table class="min-w-full">
            <thead>
              <tr>
                <th width="10" class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-orange-600 tracking-wider" />
                
                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-orange-600 tracking-wider">
                  ID order
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-orange-600 tracking-wider">
                  {{ $t('traking_number') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-orange-600 tracking-wider">
                  {{ $t('city') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-orange-600 tracking-wider">
                  {{ $t('details') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-orange-600 tracking-wider">
                  {{ $t('total_price') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-orange-600 tracking-wider">
                  {{ $t('status') }}
                </th>
              </tr>
            </thead>

            <tbody class="bg-white">
              <tr v-for="(order, ind) in refunds" :key="ind">

                <td width="10" class="border-t-2 border-gray-300 px-3">
                  <label class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                    <input :id="order.order._id" type="checkbox" class="form-checkbox rowCheckbox_refund focus:outline-none focus:shadow-outline" @click=" getRowDetailRefund($event, order, order.order._id) " />
                  </label>
                </td>

                <td class="border-t-2 border-gray-300 px-3 py-2">
                  <div class="flex items-center">
                    <div>
                      <div class="text-sm leading-5 text-gray-800">
                        {{ order.order.id }}
                      </div>
                    </div>
                  </div>
                </td>

                <td class="border-t-2 border-gray-300 px-3 py-2">
                  <div class="text-sm leading-5 siz12 text-orange-900">
                    {{ order.trackingNumber }}
                  </div>
                </td>

                <td class="border-t-2 border-gray-300 px-3 py-2">
                  <div class="text-sm leading-5 text-orange-900">
                    {{ order.order.customer.city }}
                  </div>
                </td>

                <td class="border-t-2 border-gray-300 px-3 py-2">
                  <div class="text-sm leading-5 text-orange-900">
                    {{ order.order.details.map(item => item.quantity).reduce((prev, curr) => prev + curr, 0) }}
                    {{ $t('products') }}
                  </div>
                </td>

                <td class="px-3 py-2 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                  <div class="text-sm leading-5 text-orange-900">
                    {{ order.orderObjet.totalPrice }}
                    <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
                  </div>
                </td>

                <td class="border-t-2 border-gray-300 px-3 py-2 text-center">
                  <div :class="order.status === 'delivered' ? 'bg-orange-600' : 'bg-orange-600'" class="text-sm leading-5 px-2 rounded-full text-white cursor-pointer font-medium">
                    {{ order.status }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer px-5 border0-t text-right">
        <button class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right" @click="OpenClosePopPayMethode('close', 'refunds')">
          Cancel
        </button>

        <button class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-orange-500 py-2 px-8 items-center focus:outline-none md:float-right" @click="AddRefunds('addRefunds')">
          Confirm
        </button>
      </div>
    </vue-modal-2>
  </div>
</template>

<script>
import tableBody from '@/views/payments/tableOrders.vue';
import tableTotalAmount from '@/views/payments/tableTotalAmount.vue';
import image1 from '@/assets/pay/cash.png';
import image2 from '@/assets/pay/paypal.png';
import image3 from '@/assets/pay/transfer.png';

export default {
  components: {
    TableBody: tableBody,
    TableTotalAmount: tableTotalAmount,
  },
  data() {
    return {
      formData: {
        seller: null,
        ThirdParty: null,
        date: Date.now(),
        amount: 0,
        vatFees: 0,
        details: [],
        expeditions: [],
        refunds: [],
        method: 'cash',
      },
      settings: {
        shipping: { fees: 0 },
        order: { 
          feesConfirmation: 0,
          fulfillement_fees: 0,
          upsell_fees: 0 
        },
        global_fees: 0,
        is_confirmed_fees: 0,
        quality_control: 0,
        tva: 0,
      },
      settingsSeller: {
        shipping: { fees: 0 },
        order: { 
          feesConfirmation: 0,
          fulfillement_fees: 0,
          upsell_fees: 0 
        },
        global_fees: 0,
        is_confirmed_fees: 0,
        quality_control: 0,
        tva: 0,
      },
      tva: [],
      loadingorderbyseller: false,
      ordersByseller: [],
      tvaPayement: '0',
      transfertFees: 0,
      feesVat: 0,
      confirmation_vat: 0,
      shipping_vat: 0,
      default_shipping_vat: 0,
      shipping_refund_vat: 0,
      shipping_cancel_vat: 0,
      tva: 0,
      fulfillement_fees_vat: 0,
      sellers: [],
      filtersLoad: {},
      seller: null,
      orders: [],
      totalOrders: [],
      detailsAllorders: [],
      expeditions: [],
      shippings: [],
      selectedRows: [],
      fullPage: false,
      loading: false,
      loadingPay: false,
      loadingShowPay: false,
      sellerSelect: null,
      limit: 10,
      shippingType: 'normal',
      totalfeesorder: 0,
      idWharhouse: null,
      dataCountry: this.$countries,
      cuurency: '',
      warehouse: '',
      servicesSeller: null,
      dateDelevery: {
        fromDate: null,
        toDate: null,
      },
      citiesPrices: [],
      stores: [],
      priceCity: 0,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      refunds: [],
      headings: [
        {
          value: 'Global fees',
        },
        {
          value: 'Confirmed fess',
        },
        {
          value: 'Order & Shipping',
        },
        {
          value: 'UPSELL fees'
        },
        {
          value: 'Quality control',
        },
        {
          value: 'Confirmation fees',
        },
        {
          value: 'Fulfillement fees',
        },
        {
          value: 'Shipping fees',
        },
        {
          value: 'Return fees',
        },
        {
          value: 'Cancelation fees',
        },
      ],
      options: [
        { name: 'transfer', image: 'AF' },
        { name: 'paypal', image: 'AX' },
        { name: 'cash', image: 'AL' },
      ],
      quality_control: 0,
      upsell_vat: 0,
      global_vat: 0,
      is_conf_vat: 0,
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    async warhouseSelected(oldVal, newVal) {
      await this.getwharhouseId();
      await this.getCitiesPrices();
      await this.getSellers();
      await this.getSettings();
      await this.getOrdersBySeller(this.formData.seller);
    },
  },
  async mounted() {
    await this.getwharhouseId();
    await this.getCitiesPrices();
    await this.getUser();
    await this.getSellers();
    await this.getSettings();
    await this.getAllOrdersBySeller();
  },
  methods: {
    subtotalCalculate() {
      const currency = this.idWharhouse ? this.idWharhouse.currency : '';

      if (this.global_vat > 0) {
        return `${currency} ${this.formData.details.length > 0
          ? this.formData.details
            .map(item => item.amount + item.global_vat + item.confirmation_vat)
            .reduce((acc, sum) => acc + sum, 0) 
          : 0}`;
      } else {
        return `${currency} ${this.formData.details.length > 0
          ? this.formData.details
            .map(item => 
              item.amount + 
              item.confirmation_vat + 
              item.fulfillement_fees_vat + 
              item.shipping_vat + 
              item.shipping_refund_vat + 
              item.shipping_cancel_vat + 
              item.quality_control +
              item.upsell_vat
            )
            .reduce((acc, sum) => acc + sum, 0) 
          : 0}`;
      }
    },
    async AddRefunds(name = null) {
      if (name) {
        this.$vm2.close('ModalRefunds');
        this.TotalAmountOrders();
      } else {
        await this.getRefunds({});
        if (this.refunds.length > 0) {
          this.$vm2.open('ModalRefunds');
        } else {
          alert('There are no Remboursements for the selected seller', 'warning');
        }
      }
    },
    async getRefunds() {
      if (this.formData.seller) {
        const filters = {
          seller: this.formData.seller._id || this.formData.seller,
          country: await this.warhouseSelected,
          status: 'rembourser',
          paymentGenerate: true,
          limit: 100,
        };
        this.loadingPay = true;
        const res = await this.$server.search('shippings', filters);
        this.loadingPay = false;
        if (res.content && res.content.results)
          this.refunds = res.content.results;
        else this.refunds = [];
      } else {
        alert('Seller not found !!!', 'warning');
      }
    },
    getRowDetailRefund($event, itemRef, id) {
      const itemInRow = this.formData.refunds.filter(
        item => item.order.toString() === id.toString(),
      );

      const isItemInRow = itemInRow.length > 0;
      if (isItemInRow) {

        const pos = this.formData.refunds
          .map(e => { return e.order.toString();})
          .indexOf(id.toString());
        this.formData.refunds.splice(pos, 1);
      } else {

        this.formData.refunds.push({
          order: id,
          shipping: itemRef._id,
          fees: Number.parseFloat(itemRef.order.totalPrice),
        });
      }
    },
    async getCitiesPrices() {
      const resCities2 = await this.$server.get('zones', {
        allCitiesAndFees: true,
        country: await this.warhouseSelected,
      });

      if (resCities2.content.length > 0) {
        for (const i in resCities2.content) {
          for (const j in resCities2.content[i]._id.cities) {
            this.citiesPrices.push({
              name: resCities2.content[i]._id.cities[j],
              price: resCities2.content[i]._id.price,
              zone: resCities2.content[i]._id._id,
            });
          }
        }
      } else {
        this.citiesPrices = [];
      }
    },
    async getCurrency() {
      this.warehouse = await this.warhouseSelected;
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.cuurency = res;
      });
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    getElementInArray(data, value) {
      const result = data.filter(o => {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar === value.toString();
      });
      return result ? result[0] : null;
    },
    async getAllOrdersBySeller() {
      this.loadingorderbyseller = true;
      const res = await this.$server.getOrdersByseller('orders', {
        idWharhouse: this.idWharhouse._id,
        country: await this.warhouseSelected,
        settings: this.settings,
      });
      this.loadingorderbyseller = false;
      if (res) this.ordersByseller = res;
      else this.ordersByseller = [];
    },
    async getSettings(seller = null) {
      const data = await this.$server.get('settings');

      const currentSettingW = this.getElementInArray(
        data.content.details,
        this.idWharhouse._id,
      );

      if (currentSettingW) {
        this.settings = currentSettingW;
      } else {
        this.settings = {
          shipping: { fees: 0 },
          order: {
            feesConfirmation: 0,
            fulfillement_fees: 0
          },
          global_fees: 0,
          quality_control: 0,
          is_confirmed_fees: 0,
          tva: 0
        };
      }

      if (seller) this.seller = seller;
      this.default_shipping_vat = this.settings.shipping.fees;

      if (this.seller) {
        const currentSettingSeller = this.getElementInArray(
          this.seller.fees,
          this.idWharhouse._id,
        );

        // Fees confirmation
        if ((currentSettingSeller && currentSettingSeller.confirmation === -1) || !currentSettingSeller) {
          this.confirmation_vat = this.settings.order.feesConfirmation;
        } else {
          this.confirmation_vat = currentSettingSeller.confirmation;
        }

        // Fees fulfillement
        if ((currentSettingSeller && currentSettingSeller.fulfillement_fees === -1) || !currentSettingSeller) {
          this.fulfillement_fees_vat = this.settings.order.fulfillement_fees;
        } else {
          this.fulfillement_fees_vat = currentSettingSeller.fulfillement_fees;
        }

        if ((currentSettingSeller && currentSettingSeller.shipping === -1) || !currentSettingSeller) {
          this.shipping_vat = this.settings.shipping.fees;
        } else { 
          this.shipping_vat = currentSettingSeller.shipping; 
          this.default_shipping_vat = currentSettingSeller.shipping 
        }
        
        // Cancelation shipping
        if ((currentSettingSeller && currentSettingSeller.cancelation === -1) || !currentSettingSeller) {
          this.shipping_cancel_vat = this.settings.shipping.cancelation;
        } else {
          this.shipping_cancel_vat = currentSettingSeller.cancelation;
        }

        // Refund shipping
        if ((currentSettingSeller && currentSettingSeller.refund === -1) || !currentSettingSeller) {
          this.shipping_refund_vat = this.settings.shipping.refund;
        } else {
          this.shipping_refund_vat = currentSettingSeller.refund;
        }

        // Qualite controle
        if ((currentSettingSeller && currentSettingSeller.quality_control === -1) || !currentSettingSeller) {
          this.quality_control = this.settings.quality_control;
        } else {
          this.quality_control = currentSettingSeller.quality_control;
        }

        // Tva
        if ( (currentSettingSeller && currentSettingSeller.tva === -1) || !currentSettingSeller || !currentSettingSeller.tva) {
          this.tva = this.settings.tva;
        } else {
          this.tva = currentSettingSeller.tva;
        }

        // Fees upsell
        if ((currentSettingSeller && typeof currentSettingSeller.upsell_fees === 'number' && currentSettingSeller.upsell_fees == -1) || 
          !currentSettingSeller || (currentSettingSeller && typeof currentSettingSeller.upsell_fees !== 'number')) {
          this.upsell_vat = this.settings.order.upsell_fees;
        } else {
          this.upsell_vat = currentSettingSeller.upsell_fees;
        }

        // Fees Is_Confirmed
        if ((currentSettingSeller && typeof currentSettingSeller.is_confirmed_fees === 'number' && currentSettingSeller.is_confirmed_fees == -1) || 
          !currentSettingSeller || (currentSettingSeller && typeof currentSettingSeller.is_confirmed_fees !== 'number')) {
          this.is_conf_vat = this.settings.order.is_confirmed_fees;
        } else {
          this.is_conf_vat = currentSettingSeller.is_confirmed_fees;
        }

        // Global Fees
        if ((currentSettingSeller && currentSettingSeller.global_fees === -1) || !currentSettingSeller) {
          this.global_vat = this.settings.global_fees;
        } else {
          this.global_vat = currentSettingSeller.global_fees;
        }
        
        // Check seller service
        const services = this.getElementInArray(this.seller.settings, this.idWharhouse._id);

        if (services && !services.confirmation) {
          this.confirmation_vat = 0; 
          this.upsell_vat = 0;
        }

        if (services && !services.fulfillement) {
          this.fulfillement_fees_vat = 0;
        }

        if (services && !services.shipping) {
          this.shipping_vat = this.shipping_cancel_vat = this.shipping_refund_vat = 0;
        }

        const itemsToRemove = this.global_vat > 0
        ? [ 
            'Quality control',
            'Confirmation fees',
            'Fulfillement fees',
            'Shipping fees',
            'Return fees',
            'Cancelation fees',
            'UPSELL fees'
          ] : [
            'Global fees',
            'Confirmed fess'
          ];

        this.headings = this.headings.filter(item => !itemsToRemove.includes(item.value));
      }
    },
    getImagePay(name) {
      if (name === 'cash') return image1;
      else if (name === 'paypal') return image2;
      else return image3;
    },
    setSelected(method) {
      if (method) this.formData.method = method.name;
      else this.formData.method = 'cash';
    },
    setTva(tva) {
      let tvafees = 0;
      if (!this.transfertFees) this.transfertFees = 0;
      if (Number.parseFloat(this.transfertFees) !== 0)
        tvafees += Number.parseFloat(this.transfertFees);

      if (tva) {
        if (Number.parseInt(tva) > 0) {
          this.TotalAmountOrders();
          tvafees += (this.formData.amount * Number.parseInt(tva)) / 100;
          this.TotalAmountOrders(tvafees);
        }
      } else {
        this.TotalAmountOrders(tvafees);
        this.tvaPayement = '0';
      }
      this.feesVat = Number.parseFloat(tvafees);
    },
    setTranferfees(event) {
      if (!this.transfertFees) this.transfertFees = 0;
      let fees = Number.parseFloat(this.transfertFees);
      this.TotalAmountOrders();

      if (Number.parseInt(this.tvaPayement) !== 0)
        fees +=
          (this.formData.amount * Number.parseInt(this.tvaPayement)) / 100;
      this.TotalAmountOrders(fees);
    },
    async getOrdersBySeller(seller, action = null) {
      this.orders = [];
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };

      if (seller) {
        const filters = {};
        this.loading = true;

        if (!action) {
          this.formData.seller = seller;
          this.sellerSelect = seller._id.toString();
          await this.getSeller(seller._id);
        }

        if (this.formData.seller._id.toString() === '64d60cfc05f818068c8f4750') {
          await this.$store.dispatch('wharhouse/searchStoresOrders', { status: 'PaidOrRefunded', seller: this.formData.seller._id || this.formData.seller, country: await this.warhouseSelected, table: 'shippings' }).then(res => {
            this.stores = res;
          });
        }

        this.loadingShowPay = true;

        await this.getSettings();
        await this.getTotalOrders();

        await this.getOrders(filters);
        await this.getExpedition(filters);

        await this.getSettings();

        this.loading = false;
        this.loadingShowPay = false;

      } else {
        this.sellerSelect = null;
        this.formData.ThirdParty = null;
      }
    },
    async refresh() {
      const filters = {};
      await this.getOrders(filters);
      await this.getExpedition(filters);
      await this.getSettings();
      await this.getTotalOrders();
    },
    async getStatusByName(name) {
      const result = await this.$server.get('status', { name });
      return result.content._id;
    },
    async getOrders(filter) {
      if (this.dateDelevery.fromDate && this.dateDelevery.toDate) {
        filter.dateDelevery = this.dateDelevery;
      }

      filter.seller = this.formData.seller._id;
      filter.limit = this.limit;

      filter.country = await this.warhouseSelected;
      filter.status = 'PaidOrRefunded';
      filter.page = this.paginate.currentpage++;

      this.servicesSeller = this.getElementInArray(
        this.formData.seller.settings,
        this.idWharhouse._id,
      );

      this.headings = [
        { value: 'Order & Shipping' },
        { value: 'Global fees' },
        { value: 'Confirmed fees' },
        { value: 'UPSELL fees' },
        { value: 'Quality control' },
        { value: 'Confirmation fees' },
        { value: 'Fulfillement fees' },
        { value: 'Shipping fees' },
        { value: 'Return fees' },
        { value: 'Cancellation fees' }
      ];

      const itemsToRemove = [];

      if (this.servicesSeller) {
        if (!this.servicesSeller.confirmation) itemsToRemove.push('Confirmation fees');
        if (!this.servicesSeller.fulfillement) itemsToRemove.push('Fulfillement fees');
        if (!this.servicesSeller.shipping) itemsToRemove.push('Shipping fees', 'Return fees', 'Cancellation fees');
      }

      if (this.global_vat > 0) {
        itemsToRemove.push(
          'UPSELL fees',
          'Quality control',
          'Confirmation fees',
          'Fulfillement fees',
          'Shipping fees',
          'Return fees',
          'Cancellation fees'
        );
      } else {
        itemsToRemove.push('Global fees', 'Confirmed fees');
      }

      this.headings = this.headings.filter(item => !itemsToRemove.includes(item.value));

      if (this.formData.ThirdParty) filter.ThirdParty = this.formData.ThirdParty;
      else delete filter.ThirdParty;

      const res = await this.$server.search('shippings', filter);
      if (res && res.content.results) {
        for (const i in res.content.results)
          this.orders.push(res.content.results[i]);

        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;

        this.orders.forEach(e => {
          if (e.type === 'return') e.orderObjet.totalPrice = 0;
        });
      } else {
        this.orders = [];
        this.paginate.lastpage = 1;
      }
    },
    totalorderFees( order, data, conf_fees, fulfillement_fees, shipping_fees,
      shipping_refund_fees, shipping_cancel_fees, quality_control_fees, upsell_fees, global_vat) {
      let totalfees = 0;
      let returnfees = 0;
      let cancell_fess = 0;

      const services = this.getElementInArray(order.seller.settings, this.idWharhouse._id );

      if (order.type === 'return') {
        shipping_fees = 0;
        fulfillement_fees = 0;
        conf_fees = 0;
      }

      if ( order.type === 'return' && order.status === 'refused' && services && services.shipping)
        returnfees = shipping_refund_fees;

      if ( order.type === 'return' && order.status === 'cancelled' && services && services.shipping )
        cancell_fess = shipping_cancel_fees;

      if (order.orderObjet.is_confirmed) {
        conf_fees = this.is_conf_vat;
      } else if(global_vat > 0) {
        conf_fees = 0;
      }

      let upselOrder;

      if(global_vat > 0) {
        totalfees = global_vat + conf_fees;
      } else {
        totalfees = conf_fees + fulfillement_fees + shipping_fees + returnfees + cancell_fess + quality_control_fees;
        
        // Check Upsel Order
        const upselOrder = order.order.upsel ? JSON.parse(order.order.upsel) : false;
        if (!upselOrder) {
          upsell_fees = 0;
        }
        totalfees += upsell_fees;
      }

      data.push({
        order: order.order._id,
        shipping: order._id,
        amount: order.orderObjet.totalPrice - totalfees,
        confirmation_vat: conf_fees,
        fulfillement_fees_vat: fulfillement_fees,
        shipping_vat: shipping_fees,
        shipping_refund_vat: returnfees,
        shipping_cancel_vat: cancell_fess,
        quality_control: quality_control_fees,
        upsel: upselOrder,
        upsell_vat: upsell_fees,
        global_vat: global_vat,
      });
    },
    getPriceBycity(city, array) {
      let price = 0;
      for (let i = 0; i < array.length; i++) {
        if (array[i].name.toLowerCase() === city.toLowerCase()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    },
    getPriceByZone(zone, array) {
      let price = 0;
      for (let i = 0; i < array.length; i++) {
        if (array[i].zone.toString() === zone.toString()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    },
    getIDBycity(city, array) {
      let zone = null;
      for (let i = 0; i < array.length; i++) {
        if (array[i].name.toLowerCase() === city.toLowerCase()) {
          zone = array[i].zone;
          break;
        }
      }
      return zone;
    },
    async getTotalOrders(seller = null) {
      const filter = {};
      if (seller) await this.getSettings(seller);
      filter.seller = seller ? seller._id : this.formData.seller._id;
      filter.limit = 10000;

      filter.country = await this.warhouseSelected;
      if (this.dateDelevery.fromDate && this.dateDelevery.toDate) {
        filter.dateDelevery = this.dateDelevery;
      }

      filter.status = 'PaidOrRefunded';
      if (this.formData.ThirdParty) filter.ThirdParty = this.formData.ThirdParty;
      else delete filter.ThirdParty;

      this.$insProgress.start();
      const res = await this.$server.search('shippings', filter);
      this.detailsAllorders = [];
      this.formData.details = [];

      if (res.content.results) {
        this.totalOrders = res.content.results;
        const oldShippvat = this.shipping_vat;

        for (const i in this.totalOrders) {
          const services = this.getElementInArray(this.totalOrders[i].seller.settings, this.idWharhouse._id);

          this.shipping_vat = oldShippvat;
          if (services && services.shipping) {
            if (this.totalOrders[i].orderObjet.customer.city) {} else {
              this.shipping_vat = 0;
            }
          }

          if (this.totalOrders[i].type === 'return') {
            this.totalOrders[i].orderObjet.totalPrice = 0;
            this.shipping_vat = 0;
          }

          this.totalorderFees(
            this.totalOrders[i],
            this.detailsAllorders,
            this.totalOrders[i].type !== 'return' ? this.confirmation_vat : 0,
            this.totalOrders[i].type !== 'return'? this.fulfillement_fees_vat: 0,
            this.shipping_vat,
            this.shipping_refund_vat,
            this.shipping_cancel_vat,
            this.quality_control,
            this.upsell_vat,
            this.global_vat
          );
        }
      } else {
        this.totalOrders = [];
      }
      this.$insProgress.finish();
    },
    totalOrdersAmountFees() {
      let amount = 0;
      let fees = 0;

      for (let p = 0; p < this.detailsAllorders.length; p++) {
        amount += this.detailsAllorders[p].amount;

        if(this.global_vat > 0) {
          fees += this.detailsAllorders[p].global_vat +
            this.detailsAllorders[p].confirmation_vat
        } else {
          fees += this.detailsAllorders[p].confirmation_vat +
            this.detailsAllorders[p].fulfillement_fees_vat +
            this.detailsAllorders[p].shipping_cancel_vat +
            this.detailsAllorders[p].shipping_refund_vat +
            this.detailsAllorders[p].shipping_vat +
            this.detailsAllorders[p].quality_control +
            this.detailsAllorders[p].quality_control +
            this.detailsAllorders[p].upsell_vat
        }
      }

      return { amount, fees, count: this.detailsAllorders.length };
    },
    totalfeesorderF(item) {
      if(this.global_vat > 0) {
          this.totalfeesorder = item.global_vat + item.confirmation_vat;
        } else {
          this.totalfeesorder = item.confirmation_vat + item.fulfillement_fees_vat +
            item.shipping_vat + item.shipping_refund_vat + item.shipping_cancel_vat + 
            item.quality_control + item.upsell_vat;
        }
    },
    async getShippingsType(id) {
      const filters = {};
      filters.order = id;
      filters.status = 'paid';
      const res = await this.$server.search('shippings', filters);
      if (res.content.results) this.shippingType = res.content.results[0].type;

      return this.shippingType;
    },
    async getExpedition(filterExp) {
      filterExp.seller = this.formData.seller._id;
      filterExp.status = 'received';
      filterExp.limit = 10;
      filterExp.isProcessed = false;
      filterExp.country_to = await this.warhouseSelected;
      delete filterExp.country;
      const res = await this.$server.search('expeditions', filterExp);
      if (res.content.results) this.expeditions = res.content.results;
      else this.expeditions = [];
    },
    async getShippings(filter) {
      const res = await this.$server.search('shippings', filter);
      if (res.content.results) this.shippings = res.content.results;
      else this.shippings = [];
    },
    selectAllCheckbox($event) {
      const columns = document.querySelectorAll('.rowCheckbox');

      this.formData.details = [];

      if ($event.target.checked === true) {
        columns.forEach(column => {
          column.checked = true;

          const order = this.orders.filter(item => item.order._id === column.id);

          // Check upsel Order
          const upselOrder = order[0].order.upsel ? JSON.parse(order[0].order.upsel) : false;
          
          const data = {
            order: column.id,
            shipping: order[0]._id,
            status: order[0].status,

            confirmation_vat: Number.parseInt(order[0].order.confirmation_vat),
            fulfillement_fees_vat: Number.parseInt(
              order[0].order.fulfillement_fees_vat,
            ),
            
            shipping_vat: Number.parseInt(order[0].order.shipping_vat),
            shipping_refund_vat: Number.parseInt(
              order[0].order.shipping_refund_vat,
            ),

            shipping_cancel_vat: Number.parseInt(
              order[0].order.shipping_cancel_vat,
            ),

            quality_control: Number.parseInt(order[0].order.quality_control),
            
            upsel: upselOrder,
            upsell_vat: upselOrder ? parseInt(order[0].order.upsell_vat) : 0,

            global_vat: Number.parseInt(order[0].order.global_vat),

            amount: this.TotalAmont(
              order[0].orderObjet.totalPrice,
              order[0].order.confirmation_vat,
              order[0].order.fulfillement_fees_vat,
              order[0].order.shipping_vat,
              order[0].order.shipping_refund_vat,
              order[0].order.shipping_cancel_vat,
              order[0].order.quality_control,
              order[0].order.upsell_vat, 
              upselOrder,
              order[0].order.global_vat,
            ),
          };

          this.formData.details.push(data);
        });
      } else {
        columns.forEach(column => {
          column.checked = false;
        });

        const columnsExp = document.querySelectorAll('.checkbox-exp');
        columnsExp.forEach(column => {
          column.checked = false;
        });

        this.formData.details = [];
        this.formData.expeditions = [];
      }
      this.TotalAmountOrders();
    },
    TotalAmont(total, conf_fees, ful_fees, shipp_fees, refound_fees, chang_fees, quality_control, upsel_fees, upsell, global_vat) {
      let totalA = null;

      if(global_vat > 0) {
        totalA = Number.parseFloat(total) - (Number.parseFloat(global_vat) + Number.parseFloat(conf_fees))
      } else {
        totalA = Number.parseFloat(total) - (Number.parseFloat(conf_fees) + Number.parseFloat(ful_fees) + Number.parseFloat(shipp_fees) + Number.parseFloat(refound_fees) + Number.parseFloat(chang_fees) + Number.parseFloat(quality_control));
        if (upsell) totalA = totalA - upsel_fees
      }

      return totalA;
    },
    TotalAmountOrders(tva_tarnsFees = null) {
      this.formData.amount = 0;
      
      for (const i in this.formData.details)
        this.formData.amount += this.formData.details[i].amount;

      for (const i in this.formData.expeditions)
        this.formData.amount -= (this.formData.expeditions[i].fees + this.formData.expeditions[i].packageFees);

      for (const i in this.formData.refunds)
        this.formData.amount -= this.formData.refunds[i].fees;

      this.formData.tva = this.tva;

      if(this.global_vat > 0 ) {
        this.formData.totalFees = this.formData.details
          .map( item => item.global_vat + item.confirmation_vat).flat()
          .reduce((acc, sum) => acc + sum);
      } else {
        this.formData.totalFees = this.formData.details
          .map(
            item =>
              item.confirmation_vat +
              item.fulfillement_fees_vat +
              item.shipping_vat +
              item.shipping_refund_vat +
              item.shipping_cancel_vat +
              item.quality_control +
              item.upsell_vat
          )
          .flat()
          .reduce((acc, sum) => acc + sum);
      }


      this.formData.vatFees = (this.formData.totalFees * this.tva) / 100;

      if (Number.parseFloat(tva_tarnsFees) > 0)
        this.formData.amount -= tva_tarnsFees;

      this.formData.amount -= this.formData.vatFees;
    },
    TotalFees() {
      let confirmation_vat = 0;
      let fulfillement_fees_vat = 0;

      let shipping_vat = 0;
      let shipping_refund_vat = 0;

      let shipping_cancel_vat = 0;
      let quality_control = 0;
      
      let upsell_vat = 0;

      let global_vat = 0;

      for (const i in this.formData.details) {
        if(this.global_vat > 0) {
          global_vat += this.formData.details[i].global_vat;
        } else {
          confirmation_vat += this.formData.details[i].confirmation_vat;
          fulfillement_fees_vat += this.formData.details[i].fulfillement_fees_vat;
          shipping_vat += this.formData.details[i].shipping_vat;
          shipping_refund_vat += this.formData.details[i].shipping_refund_vat;
          shipping_cancel_vat += this.formData.details[i].shipping_cancel_vat;
          quality_control += this.formData.details[i].quality_control;
          upsell_vat += this.formData.details[i].upsell_vat;
        }
      }

      if(this.global_vat > 0) {
        return (global_vat + confirmation_vat);
      } else {
        return (
          confirmation_vat +
          fulfillement_fees_vat +
          shipping_vat +
          shipping_refund_vat +
          shipping_cancel_vat +
          quality_control +
          upsell_vat
        );
      }
    },
    UpdateRowFees(id, data1, data2, data3, data4, data5, data6, data7, amount) {
      this.formData.details.filter(item => {
        if (item.order === id) {
          item.confirmation_vat = Number.parseInt(data1);
          item.fulfillement_fees_vat = Number.parseInt(data2);
          item.shipping_vat = Number.parseInt(data3);
          item.shipping_refund_vat = Number.parseInt(data4);
          item.shipping_cancel_vat = Number.parseInt(data5);
          item.quality_control = Number.parseInt(data6);
          item.upsell_vat = parseInt(data7);
          item.global_vat = Number.parseInt(data8);
          item.amount = amount;
        }
      });
      this.TotalAmountOrders();
    },
    getRowDetailExp($event, itemExp, id) {
      const itemInRow = this.formData.expeditions.filter(
        item => item.id === id,
      );
      const isItemInRow = itemInRow.length > 0;
      if (isItemInRow) {
        const pos = this.formData.expeditions
          .map(e => {
            return e.id;
          })
          .indexOf(id);
        this.formData.expeditions.splice(pos, 1);
      } else {
        const data = {
          id,
          fees: Number.parseInt(itemExp.fees),
          packageFees: Number.parseInt(itemExp.packageFees),
        };
        this.formData.expeditions.push(data);
      }
      this.TotalAmountOrders();
      // 
    },
    getRowDetail($event, item, id) {
      const itemInRow = this.formData.details.filter(item => item.order === id);
      const isItemInRow = itemInRow.length > 0;

      if (isItemInRow) {
        const pos = this.formData.details
          .map(e => {
            return e.order;
          })
          .indexOf(id);
        this.formData.details.splice(pos, 1);
      } else {
        // Check upsel Order
        const upselOrder = item.order.upsel ? JSON.parse(item.order.upsel) : false;

        const data = {
          order: id,
          shipping: item._id,

          status: item.status,
          confirmation_vat: Number.parseInt(item.order.confirmation_vat),

          fulfillement_fees_vat: Number.parseInt(
            item.order.fulfillement_fees_vat,
          ),

          shipping_vat: Number.parseInt(item.order.shipping_vat),
          shipping_refund_vat: Number.parseInt(item.order.shipping_refund_vat),

          shipping_cancel_vat: Number.parseInt(item.order.shipping_cancel_vat),
          quality_control: Number.parseInt(item.order.quality_control),

          upsel: upselOrder,
          upsell_vat: upselOrder ? parseInt(item.order.upsell_vat) : 0,

          global_vat: Number.parseInt(item.order.global_vat),

          amount: this.TotalAmont(
            item.orderObjet.totalPrice,
            item.order.confirmation_vat,
            item.order.fulfillement_fees_vat,
            item.order.shipping_vat,
            item.order.shipping_refund_vat,
            item.order.shipping_cancel_vat,
            item.order.quality_control,
            item.order.upsell_vat, 
            upselOrder, 
            item.order.global_vat,
          ),
        };

        this.formData.details.push(data);
      }
      if (this.formData.details.length === 0) {
        const columns = document.querySelectorAll('.checkallbbox');
        columns.forEach(column => {
          column.checked = false;
        });
        const columnsExp = document.querySelectorAll('.checkbox-exp');
        columnsExp.forEach(column => {
          column.checked = false;
        });
        this.formData.expeditions = [];
      }
      this.TotalAmountOrders();
    },
    async getSellers() {
      const filter = {
        type: 'Seller',
        countries: await this.warhouseSelected,
        limit: this.limit,
      };
      const res = await this.$server.search('users', filter);
      if (res && res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    },
    searchSellers: _.debounce(async function (search) {
      const filter = {
        type: 'Seller',
        countries: await this.warhouseSelected,
        limit: this.limit,
        name: search,
      };
      const res = await this.$server.find('users', filter);

      if (res && res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    }, 500),
    async getSeller(id) {
      const filter = {
        _id: id,
      };
      const res = await this.$server.search('users', filter);
      if (res.content.results) this.seller = res.content.results[0];
      else this.seller = null;
    },
    async save() {
      const modal_id = 'ModalPay';
      if (this.formData.details.length > 0) {
        this.loadingPay = true;
        this.$insProgress.start();
        this.formData.transfert_fees = Number.parseFloat(this.transfertFees);
        this.formData.country = await this.warhouseSelected;
        this.formData.count = this.formData.details.length;

        const data = await this.$server.create('payments', this.formData);
        this.loadingPay = false;
        this.$insProgress.finish();

        if (data && data._id) {
          this.formData.details = [];
          this.formData.ThirdParty = null;
          this.formData.expeditions = [];
          this.shippings = [];
          this.$vm2.close(modal_id);
          await this.refresh();
          this.$router.push('/payments');
          alert(this.$t('payement_created'), 'success');
        }
      } else {
        alert(this.$t('no_order_selected'), 'warning');
      }
    },
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async OpenClosePopPayMethode(action, type = null, seller = null) {
      let modal_id = 'ModalPay';
      if (type === 'allOrders') this.loadingShowPay = true;
      if (type === 'refunds') modal_id = 'ModalRefunds';

      if (seller) {
        this.sellerSelect = seller._id.toString();
        await this.getTotalOrders(seller);
      } else {
        this.sellerSelect = null;
      }

      if (type === 'allOrders') {
        this.formData.details = [];
        this.formData.amount = 0;
        this.formData.details = this.detailsAllorders;

        if (seller) {
          this.formData.seller = seller;
          await this.getSettings(seller);
        }
        this.formData.amount = this.totalOrdersAmountFees().amount;
        this.loadingShowPay = false;
      }
      if (action === 'open') {
        if (this.formData.details.length > 0) {
          this.TotalAmountOrders();
          this.$vm2.open(modal_id);
        } else {
          alert(this.$t('no_order_selected'), 'warning');
        }
      } else {
        if (type && type === 'refunds') {
          this.formData.refunds = [];
          const columns = document.querySelectorAll('.rowCheckbox_refund');
          columns.forEach(column => {
            column.checked = false;
          });
          this.TotalAmountOrders();
        } else {
          this.formData.details = [];
          this.formData.amount = 0;
          const columns = document.querySelectorAll('.rowCheckbox');
          columns.forEach(column => {
            column.checked = false;
          });
        }
        this.$vm2.close(modal_id);
      }
    },
    async loadMore() {
      let page = 0;
      page = ++this.paginate.currentpage;
      const filters = {
        page,
        limit: this.limit,
      };
      this.getOrders(filters);
    },
    async FindOrderByBetweenDate() {
      this.orders = [];
      const filters = {};
      this.paginate.currentpage = 1;
      this.loading = true;
      this.getOrders(filters);
      await this.getTotalOrders();
      this.loading = false;
    },
    async reset() {
      this.orders = [];
      this.paginate.currentpage = 1;
      this.dateDelevery.fromDate = null;
      this.dateDelevery.toDate = null;
      await this.getOrdersBySeller(this.formData.seller);
      await this.getTotalOrders();
    },
    async paginatation(direction) {
      let page = 0;
      if (direction === 'next') page = ++this.paginate.currentpage;
      else page = --this.paginate.currentpage;

      const filters = {
        page,
        limit: this.limit,
      };
      this.getOrders(filters);
    },
  },
};
</script>

<style scped>
.loading-amount svg {
  width: 20px;
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.border-top {
  border-top: 1px dashed #8d9091 !important;
}

.table-nowrap td,
.table-nowrap th {
  white-space: nowrap;
}

.table-borderless> :not(caption)>*>* {
  border-bottom-width: 0;
}

.align-middle {
  vertical-align: middle !important;
}

.invoice-table tbody:last-child {
  border: none;
}

.invoice-table .table>tbody {
  vertical-align: inherit;
}

.invoice-table .table-nowrap td,
.invoice-table .table-nowrap th {
  white-space: nowrap;
}

.invoice-table .table th {
  font-weight: 500;
  text-align: left;
  font-size: 15px;
}

.invoice-table .table-borderless> :not(caption)>*>* {
  border-bottom-width: 0;
}

.invoice-table .table-sm> :not(caption)>*>* {
  padding: 0.3rem 0.25rem;
}

.invoice-table .bg-light {
  background-color: #f3f6f9;
}

.invoice-table .border-0 {
  border: 0 !important;
}

.invoice-table .form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #f3f6f9;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.siz12 {
  font-size: 12px;
}

.empty-row {
  background: repeating-linear-gradient(53deg,
  #bfc0c2 4%,
  #fcfcff 11px 6%,
  #ffffff 10px 7%,
  #9d9c9c 15px);
}

.item-tab {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: fadeInUp;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10%) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0%) scale(1);
  }
}

.btn-16::after {
  position: absolute;
  content: '';
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  direction: rtl;
  z-index: -1;
  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;
  transition: all 0.3s ease;
}

.custom-btn {
  height: 40px;
  border-radius: 5px;
  padding: 10px 25px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
    7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
  outline: none;
  border: none;
  color: #000;
}

.btn-16:hover:after {
  left: auto;
  right: 0;
  width: 100%;
}

.total-amount svg {
  width: 35px;
}

.text-xss {
  font-size: 11px;
}

.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked~.toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.flag-img {
  display: inline-block;
  height: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}

.tag_cities {
  width: 100%;
  max-width: 100%;
}

.vs__dropdown-toggle {
  border: none;
}

.tag_cities .tag {
  background: rgb(49 130 206 / 16%);
  border-radius: 20px;
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2px;
  margin-bottom: 5px;
  min-height: 28px;
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-right: 0;
}

.vs-chip--text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: 10px;
}

.vs-chip--close {
  width: 20px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}

.tag_cities .tag [data-role='remove']::after {
  content: 'x';
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}

.tag_cities .tag [data-role='remove'] {
  margin-left: 8px;
  cursor: pointer;
}

.top-100 {
  top: 100%;
}

.bottom-100 {
  bottom: 100%;
}

.max-h-select {
  max-height: 300px;
}

[type='checkbox'] {
  box-sizing: border-box;
  padding: 0;
}

.form-payement {
  min-height: 400px;
}

dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

.app-theme .btn.btn-prime {
  background: #444;
  background: linear-gradient(#555, #444);
  color: #fff;
  font-weight: 500;
}

.app-theme .btn {
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
  transition: ease-in 0.1s;
  font-size: inherit;
}

svg:not(:root).svg-inline--fa {
  overflow: visible;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
</style>
